/**
 * Uploaded File
 */
export class File {
    #client;
    /**
     * File Id
     */
    id;
    /**
     * File bucket
     */
    tag;
    /**
     * Original filename
     */
    filename;
    /**
     * Parsed metadata of the file
     */
    metadata;
    /**
     * Raw content type of this file
     */
    contentType;
    /**
     * Size of the file (in bytes)
     */
    size;
    /**
     * Construct File
     * @param client Client
     * @param file File
     */
    constructor(client, file) {
        this.#client = client;
        this.id = file._id;
        this.tag = file.tag;
        this.filename = file.filename;
        this.metadata = file.metadata;
        this.contentType = file.content_type;
        this.size = file.size;
    }
    /**
     * Direct URL to the file
     */
    // get url(): string {
    //   if (!this.filename) return this.previewUrl;
    //
    //   return `${this.#client.configuration?.features.autumn.url}/${this.tag}/${
    //     this.id
    //   }/${this.filename}`;
    // }
    /**
     * Preview URL for the file
     */
    get previewUrl() {
        return `${this.#client.configuration?.features.autumn.url}/${this.tag}/${this.id}`;
    }
    /**
     * Original download URL for the file
     */
    get originalUrl() {
        // PeyPhone: link straight to /{tag}/{id}/{filename} instead of /original.
        // `/original` answers with a 308 redirect, and Autumn behind a path-prefix proxy
        // used to drop the `/autumn` prefix from it (full image / video / download broke).
        // Direct URL = one request less, and works for <video>/<a download> Range requests.
        const base = `${this.#client.configuration?.features.autumn.url}/${this.tag}/${this.id}`;
        return this.filename
            ? `${base}/${encodeURIComponent(this.filename)}`
            : `${base}/original`;
    }
    /**
     * Whether the file is a playable video, even if the server classified it as a
     * generic "File" (Autumn without ffprobe stored iPhone .MOV etc. as File).
     */
    get isVideo() {
        return (this.metadata?.type === "Video" ||
            (this.metadata?.type === "File" &&
                (this.contentType?.startsWith("video/") ?? false)));
    }
    /**
     * Human readable file size
     */
    get humanReadableSize() {
        if (!this.size)
            return "Unknown size";
        if (this.size > 1e6) {
            return `${(this.size / 1e6).toFixed(2)} MB`;
        }
        else if (this.size > 1e3) {
            return `${(this.size / 1e3).toFixed(2)} KB`;
        }
        return `${this.size} B`;
    }
    /**
     * Whether this file should have a spoiler
     */
    get isSpoiler() {
        return this.filename?.toLowerCase().startsWith("spoiler_") ?? false;
    }
    /**
     * Creates a URL to a given file with given options.
     * @param forceAnimation Returns GIF if applicable (for avatars/icons)
     * @returns Generated URL or nothing
     */
    createFileURL(forceAnimation) {
        const autumn = this.#client.configuration?.features.autumn;
        if (!autumn?.enabled)
            return;
        let query = "";
        if (forceAnimation && this.contentType === "image/gif") {
            query = "/original";
        }
        return `${autumn.url}/${this.tag}/${this.id}${query}`;
    }
}
